import React from "react";
import { Quote, Star } from "lucide-react";

const TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/1d8d6f75-1116-44e7-832c-39bdf552935e/images/77e19e65ccd6a81b05222a6d9981cbfd9a1cf344ed1ccdfb451bc754edfb9c80.png";

const REVIEWS = [
  {
    quote:
      "Rafael has been looking after our garden every week for ages now — lawn always crisp, borders kept neat and he genuinely cares about getting things right. Couldn't recommend more.",
    name: "George",
    location: "Farnham Common · Weekly client",
    rating: 5,
  },
  {
    quote:
      "Reliable, friendly and tidy. Turns up every week without fail and the garden has never looked better. A pleasure to have around the place.",
    name: "Mark",
    location: "Beaconsfield · Weekly client",
    rating: 5,
  },
  {
    quote:
      "We've had Rafael in weekly for our garden maintenance and he's brilliant — proper attention to detail, lovely manner and always leaves it spotless. Highly recommend.",
    name: "Simon",
    location: "Jordans Village · Weekly client",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 lg:px-14 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.5] pointer-events-none"
        style={{
          backgroundImage: `url(${TEXTURE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-brand-sand/55" />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-terracotta">
            Kind words
          </span>
          <h2
            data-testid="testimonials-heading"
            className="mt-3 font-display font-bold text-brand-moss-deep text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            Lovely people, lovely<br />gardens, lovely reviews.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-3xl p-8 border border-brand-line shadow-sm hover:shadow-md transition-shadow flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <div className="flex">
                  {Array.from({ length: r.rating }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-brand-terracotta text-brand-terracotta" />
                  ))}
                </div>
                <Quote className="w-7 h-7 text-brand-moss/20" />
              </div>
              <p className="text-brand-charcoal text-[15px] leading-relaxed flex-1">
                "{r.quote}"
              </p>
              <div className="mt-6 pt-5 border-t border-brand-line">
                <div className="font-display font-semibold text-brand-moss-deep">{r.name}</div>
                <div className="text-xs text-brand-charcoal/70 uppercase tracking-wider mt-1">{r.location}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
